var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73036 19C1.2375 19 0.826071 18.8374 0.496071 18.5123C0.165357 18.1865 0 17.7808 0 17.2953V1.70472C0 1.21917 0.165357 0.813833 0.496071 0.488722C0.826071 0.162907 1.2375 0 1.73036 0H10.1786L15 4.75V17.2953C15 17.7808 14.835 18.1862 14.505 18.5113C14.1743 18.8371 13.7625 19 13.2696 19H1.73036ZM9.64286 5.27778H13.9286L9.64286 1.05556V5.27778Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.869e029840018f5b53cd6731d3285f27.svg";
export { ForwardRef as ReactComponent };